module.exports = __webpack_public_path__ + "static/demo-c1f5b04facb89c790a8ccbe681d169e9.gif";